import React from "react";
import { useTranslation } from "react-i18next";
import { AITeamMateTitleContainer, AITeamMateTextStyle, BetaTagContainer, BetaTagText } from "./Styles";
import { ReactComponent as AIChatBotIcon } from "../../assets/svg/teammate-ai.svg";

const AITeamMateTitle = () => {
  const { t } = useTranslation();
  return (
    <AITeamMateTitleContainer>
      <AIChatBotIcon style={{ width: "14px", height: "14px", fontSize: "14px", fontWeight: 600 }} />
      <AITeamMateTextStyle>{t("ai_chat_bot.chat_bot_name")}</AITeamMateTextStyle>
      <BetaTagContainer>
        <BetaTagText>BETA</BetaTagText>
      </BetaTagContainer>
    </AITeamMateTitleContainer>
  );
};

export { AITeamMateTitle };
